export default __webpack_public_path__ + "static/media/ISC-West-2019-Event-Pic.37196488.png";